import { render, staticRenderFns } from "./TbGuanLi.vue?vue&type=template&id=400a19ba&scoped=true"
import script from "./TbGuanLi.vue?vue&type=script&lang=js"
export * from "./TbGuanLi.vue?vue&type=script&lang=js"
import style0 from "./TbGuanLi.vue?vue&type=style&index=0&id=400a19ba&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "400a19ba",
  null
  
)

export default component.exports